import { render, staticRenderFns } from "./Especifica.vue?vue&type=template&id=acf76882&scoped=true&"
import script from "./Especifica.vue?vue&type=script&lang=js&"
export * from "./Especifica.vue?vue&type=script&lang=js&"
import style0 from "./Especifica.vue?vue&type=style&index=0&id=acf76882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf76882",
  null
  
)

export default component.exports